import {
	CREATE_NOTIFICATION,
	GET_NOTIFICATIONS,
	UPDATE_NOTIFICATION,
	DELETE_NOTIFICATION,
	GET_ERRORS
} from "../actions/types";

const initialState = {
	notifications: [],
	error: '',
	actionType: ''
};

export default function (state = initialState, action) {
	switch (action.type) {
		case CREATE_NOTIFICATION:
			return {
				...state,
				actionType: action.type
			};
		case UPDATE_NOTIFICATION:
			return {
				...state,
				actionType: action.type
			};
		case DELETE_NOTIFICATION:
			return {
				...state,
				actionType: action.type
			};
		case GET_NOTIFICATIONS:
			return {
				...state,
				actionType: action.type,
				notifications: action.payload.notifications,
				total: action.payload.total,
			};
		case GET_ERRORS:
			return {
				...state,
				actionType: action.type,
				error: action.payload
			};
		default:
			return state;
	}
}
